import { CreatePartFinderBatchEntry } from '@/api/generatedApi';
import { SkipReason, validatePartNumberFormat } from './partNumberValidation';

const HEADER_ROW_OFFSET = 2;

export interface SkippedRow {
  row: number;
  reason: SkipReason;
}

export interface ColumnExtraction {
  entries: CreatePartFinderBatchEntry[];
  validCount: number;
  duplicatesRemoved: number;
  skippedRows: SkippedRow[];
}

export const extractColumnEntries = (rows: string[][], columnIndex: number): ColumnExtraction => {
  const entries: CreatePartFinderBatchEntry[] = [];
  const seen = new Set<string>();
  const skippedRows: SkippedRow[] = [];
  let duplicatesRemoved = 0;

  for (const [index, row] of rows.entries()) {
    const rowNumber = index + HEADER_ROW_OFFSET;
    const value = (row[columnIndex] ?? '').trim();

    if (row.every(cell => (cell ?? '').trim() === '')) {
      continue;
    }

    const format = validatePartNumberFormat(value);
    if (!format.valid) {
      skippedRows.push({ row: rowNumber, reason: format.reason });
      continue;
    }

    const key = value.toLowerCase();
    if (seen.has(key)) {
      duplicatesRemoved += 1;
      continue;
    }
    seen.add(key);
    entries.push({ partNumber: value });
  }

  return { entries, validCount: entries.length, duplicatesRemoved, skippedRows };
};
